import React from "react";
import { LoadingButton } from "@mui/lab";
import { Box, Button } from "@mui/material";

type Props = {
  steps: string[];
  activeStep: number;
  onClick?: () => void;
  onClickBack?: () => void;
  loading?: boolean;
  formId?: string
};

function ButtonStepper({
  steps,
  activeStep,
  onClick,
  onClickBack,
  loading,
  formId
}: Props) {
  const isLastStep = activeStep === steps.length;

  return (
      <Box
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
          gap: 2
        }}
      >
        {activeStep > 1 && (
          <Button
            type="button"
            color="primary"
            variant="outlined"
            fullWidth
            onClick={onClickBack}
          >
            Back
          </Button>
        )}
        <LoadingButton
          type="submit"
          color="primary"
          variant="contained"
          fullWidth
          onClick={onClick}
          loading={loading}
          form={formId}
        >
          {isLastStep ? "Submit" : "Next"}
        </LoadingButton>
      </Box>
  );
}

export default ButtonStepper;
